import CRUDFormComponent from '../../components/CRUDFormComponent'

const PhysicalExamsForm = () => {
  const fields = [{ key: 'name', label: 'Nombre', type: 'string' }]

  return (
    <>
      <CRUDFormComponent
        entityName={{ singular: 'Examen físico' }}
        fields={fields}
        entityUrl="/physical-exams"
      />
    </>
  )
}

export default PhysicalExamsForm
